module.exports = {
  CHARGING: 'charging',
  ENDED: 'ended',
  FAILED: 'failed',
};
